import { TabContainerItem } from './tab-container-item';
export default TabContainerItem;
